/* ion-cart-extras.js — persistent drawer logic for the native UpCart replica
   (Ionix Labs). Everything uses event delegation so it survives the Dawn drawer
   re-renders. Owns: free-shipping bar animation, upsell "Add to order" button,
   upsell variant price sync, back-forward cache restore.
   Line steppers and remove buttons are Dawn's own (cart.js / quantity-input). */
(function () {
  if (window.__ionCartExtras) return;
  window.__ionCartExtras = true;

  var busy = false;

  function drawer() { return document.querySelector('cart-drawer'); }
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function sectionsParam() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function refresh(json) {
    var d = drawer();
    if (!d || !json || !json.sections) {
      window.location.href = (window.routes && routes.cart_url) || '/cart';
      return;
    }
    if (d.classList.contains('is-empty')) d.classList.remove('is-empty');
    if (typeof d.renderContents === 'function') {
      try { d.renderContents(json); animateBar(); return; } catch (e) { /* caminho manual abaixo */ }
    }
    try {
      var src = new DOMParser().parseFromString(json.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      var dst = document.getElementById('CartDrawer');
      if (src && dst) dst.innerHTML = src.innerHTML;
      var bs = json.sections['cart-icon-bubble'] && new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      var bd = document.getElementById('cart-icon-bubble');
      if (bs && bd) bd.innerHTML = bs.innerHTML;
      setTimeout(function () { d.classList.add('animate', 'active'); });
      document.body.classList.add('overflow-hidden');
      animateBar();
    } catch (e) {
      window.location.href = (window.routes && routes.cart_url) || '/cart';
    }
  }

  function addItems(items) {
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sectionsParam(), sections_url: window.location.pathname })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  /* ---------- barra de frete grátis: anima o preenchimento ----------
     A gaveta é re-renderizada pelo servidor a cada mudança do carrinho, então o
     elemento da barra é sempre novo e nasce já na largura final: sem isto não há
     transição nenhuma. Guardamos a última porcentagem e, a cada render, plantamos
     a largura antiga sem transição, forçamos reflow e só então soltamos a nova. */
  var lastPct = null;

  function animateBar() {
    var fill = document.querySelector('.ion-rewards__fill');
    if (!fill) return;
    var target = parseFloat(fill.dataset.ionPct || '0');
    if (isNaN(target)) return;
    if (fill.dataset.ionAnimated === '1') return;
    fill.dataset.ionAnimated = '1';

    var from = lastPct === null ? target : lastPct;
    if (from !== target) {
      fill.classList.add('is-instant');
      fill.style.width = from + '%';
      void fill.offsetWidth; /* reflow: fixa o ponto de partida */
      fill.classList.remove('is-instant');
      requestAnimationFrame(function () { fill.style.width = target + '%'; });
    }
    lastPct = target;
  }

  /* a gaveta é substituída inteira a cada re-render (nosso refresh e o cart.js
     do tema), então observamos o container em vez de amarrar num caminho só */
  function watchDrawer() {
    var host = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!host || host.dataset.ionObserved === '1') return;
    host.dataset.ionObserved = '1';
    new MutationObserver(function () { animateBar(); }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchDrawer(); animateBar(); });
  } else {
    watchDrawer();
    animateBar();
  }

  /* ---------- upsell ---------- */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.ion-upsell__add');
    if (!btn || btn.disabled || busy) return;
    var tile = btn.closest('.ion-upsell__tile');
    if (!tile) return;
    var sel = tile.querySelector('.ion-upsell__variant-row select');
    var vid = sel ? parseInt(sel.value, 10) : parseInt(tile.getAttribute('data-variant-id') || '0', 10);
    if (!vid) return;
    busy = true;
    btn.disabled = true;
    addItems([{ id: vid, quantity: 1 }])
      .then(refresh)
      .catch(function () { btn.disabled = false; })
      .then(function () { busy = false; });
  });

  document.addEventListener('change', function (ev) {
    var sel = ev.target.closest && ev.target.closest('.ion-upsell__variant-row select');
    if (!sel) return;
    var tile = sel.closest('.ion-upsell__tile');
    if (!tile) return;
    var opt = sel.options[sel.selectedIndex];
    var price = parseInt(opt.getAttribute('data-price') || '0', 10);
    var cap = parseInt(opt.getAttribute('data-cap') || '0', 10);
    var priceEl = tile.querySelector('.ion-upsell__price');
    var cmpEl = tile.querySelector('.ion-upsell__compare');
    function money(cents) { return '$' + (cents / 100).toFixed(2); }
    if (priceEl && price) priceEl.textContent = money(price);
    if (cmpEl) {
      if (cap > price) { cmpEl.hidden = false; cmpEl.textContent = money(cap); }
      else { cmpEl.hidden = true; }
    }
  });

  /* volta do checkout (bfcache): reabilita o que ficou desativado */
  window.addEventListener('pageshow', function () {
    busy = false;
    document.querySelectorAll('.ion-upsell__add[disabled]').forEach(function (b) { b.disabled = false; });
  });
})();
